/* @flow */
import * as React from 'react';

const Dinnerware = props => (
  <svg
    width={126}
    height={93}
    viewBox="0 0 126 93"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M89.343,38.206 L64.202,38.206 L64.202,52.143 C64.202,60.597 61.778,66.106 62.885,75.819 C64.202,87.376 77.186,91.376 77.186,91.376 L89.343,91.376 L101.5,91.376 C101.5,91.376 114.608,89.376 115.801,77.819 C116.805,68.095 114.484,60.597 114.484,52.143 L114.484,38.206 L89.343,38.206 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M112.234,32.746 L66.454,32.746 C63.99,32.746 61.993,35.743 61.993,38.206 L61.993,38.206 L116.694,38.206 L116.694,38.206 C116.694,35.743 114.697,32.746 112.234,32.746"
    />
    <path d="M112.234,32.746 L66.454,32.746 C63.99,32.746 61.993,35.743 61.993,38.206 L61.993,38.206 L116.694,38.206 L116.694,38.206 C116.694,35.743 114.697,32.746 112.234,32.746 Z" />
    <path d="M100.029,32.746 C100.029,26.526 95.245,24.024 89.343,24.024 C83.441,24.024 78.657,26.526 78.657,32.746" />
    <path
      strokeWidth={5}
      d="M97.463,26.502 C95.503,24.782 92.593,24.023 89.344,24.023 C86.096,24.023 83.187,24.782 81.227,26.5"
    />
    <path stroke="#FFFFFF" strokeWidth={1.5} d="M108,38.206 L108,42.648" />
    <path stroke="#FFFFFF" strokeWidth={1.5} d="M103,38.206 L103,44.059" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      d="M114.484,43.417 L122.332,43.417 C123.329,43.417 124.138,44.225 124.138,45.223 L124.138,45.223 C124.138,46.034 123.597,46.736 122.818,46.961 C121.418,47.366 119.274,48.252 118.282,50.037 C117.574,51.309 116.308,52.168 114.852,52.168 L114.484,52.168"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      d="M64.203,43.417 L56.355,43.417 C55.358,43.417 54.549,44.225 54.549,45.223 L54.549,45.223 C54.549,46.034 55.09,46.736 55.869,46.961 C57.269,47.366 59.413,48.252 60.405,50.037 C61.113,51.309 62.379,52.168 63.835,52.168 L64.203,52.168"
    />
    <path d="M114.484,43.417 L122.332,43.417 C123.329,43.417 124.138,44.225 124.138,45.223 L124.138,45.223 C124.138,46.034 123.597,46.736 122.818,46.961 C121.418,47.366 119.274,48.252 118.282,50.037 C117.574,51.309 116.308,52.168 114.852,52.168 L114.484,52.168" />
    <path d="M64.203,43.417 L56.355,43.417 C55.358,43.417 54.549,44.225 54.549,45.223 L54.549,45.223 C54.549,46.034 55.09,46.736 55.869,46.961 C57.269,47.366 59.413,48.252 60.405,50.037 C61.113,51.309 62.379,52.168 63.835,52.168 L64.203,52.168" />
    <path d="M89.343,38.206 L64.202,38.206 L64.202,52.143 C64.202,60.597 60.781,67.273 62.885,76.819 C66.093,91.376 81.186,91.376 81.186,91.376 L89.343,91.376" />
    <path d="M89.343,38.206 L114.484,38.206 L114.484,52.143 C114.484,60.597 117.905,67.273 115.801,76.819 C112.593,91.376 97.5,91.376 97.5,91.376 L89.343,91.376" />
    <path d="M56.549,84.455 L1.5,84.455 L1.5,85.908 C1.5,88.928 3.948,91.375 6.967,91.375 L51.082,91.375 C54.101,91.375 56.549,88.928 56.549,85.908 L56.549,84.455 Z" />
    <path d="M56.549,77.535 L1.5,77.535 L1.5,78.988 C1.5,82.008 3.948,84.455 6.967,84.455 L51.082,84.455 C54.101,84.455 56.549,82.008 56.549,78.988 L56.549,77.535 Z" />
    <path d="M56.549,70.615 L1.5,70.615 L1.5,72.067 C1.5,75.088 3.948,77.534 6.967,77.534 L51.082,77.534 C54.101,77.534 56.549,75.088 56.549,72.067 L56.549,70.615 Z" />
    <path d="M51.082,63.694 L6.967,63.694 L6.967,65.147 C6.967,68.167 9.415,70.614 12.434,70.614 L45.615,70.614 C48.634,70.614 51.082,68.167 51.082,65.147 L51.082,63.694 Z" />
    <path d="M51.082,56.774 L6.967,56.774 L6.967,58.227 C6.967,61.247 9.415,63.694 12.434,63.694 L45.615,63.694 C48.634,63.694 51.082,61.247 51.082,58.227 L51.082,56.774 Z" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      d="M8.864,1.5 C8.391,3.561 8.121,14.409 8.121,16.744 C8.121,27.061 13.172,31.768 19.404,31.768 C25.635,31.768 30.686,27.061 30.686,16.744 C30.686,14.409 30.416,3.561 29.943,1.5 L8.864,1.5 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      d="M29.023,25.494 C31.086,29.47 34.329,31.768 37.977,31.768 C44.208,31.768 49.259,27.061 49.259,16.745 C49.259,14.409 48.989,3.561 48.516,1.5 L29.938,1.5"
    />
    <path stroke="#FFFFFF" strokeWidth={1.5} d="M43.458,1.5 L38.71,6.248" />
    <path stroke="#FFFFFF" strokeWidth={1.5} d="M17.804,2.5 L15.056,5.248" />
    <path stroke="#FFFFFF" strokeWidth={1.5} d="M25.804,1.5 L20.056,7.248" />
    <path d="M8.864,1.5 C8.391,3.561 8.121,14.409 8.121,16.744 C8.121,27.061 13.172,31.768 19.404,31.768 C25.635,31.768 30.686,27.061 30.686,16.744 C30.686,14.409 30.416,3.561 29.943,1.5 L8.864,1.5 Z" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      d="M27.087,56.774 C27.432,56.455 27.111,51.087 19.404,51.087 C11.697,51.087 11.376,56.455 11.72,56.774 L27.087,56.774 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      d="M45.66,56.774 C46.005,56.455 45.684,51.087 37.977,51.087 C30.27,51.087 29.949,56.455 30.293,56.774 L45.66,56.774 Z"
    />
    <path d="M27.087,56.774 C27.432,56.455 27.111,51.087 19.404,51.087 C11.697,51.087 11.376,56.455 11.72,56.774 L27.087,56.774 Z" />
    <path d="M19.403,31.768 L19.403,50.848" />
    <path d="M29.023,25.494 C31.086,29.47 34.329,31.768 37.977,31.768 C44.208,31.768 49.259,27.061 49.259,16.745 C49.259,14.409 48.989,3.561 48.516,1.5 L29.938,1.5" />
    <path d="M45.66,56.774 C46.005,56.455 45.684,51.087 37.977,51.087 C30.27,51.087 29.949,56.455 30.293,56.774 L45.66,56.774 Z" />
    <path d="M37.976,31.768 L37.976,50.848" />
  </svg>
);

export default Dinnerware;



// WEBPACK FOOTER //
// ./src/assets/images/icons/dinnerware.js